export const VERSION_TYPES = [
    'CLEAN',
    'DIRTY',
    'DJ_EDIT',
    'INTRO',
    'ACAPELLA_IN',
    'ACAPELLA_OUT',
    'PARTY_STARTER',
    'PARTY_STARTERS',
    'TRANS',
    'TRANSITION',
    'HYPE_EDIT',
    'BREAKS',
    'REMIX',
    'EXCLUSIVE_REMIX',
    'EXCLUSIVE_REMIX_2',
    'BOOTLEG',
    'EXCLUSIVE_BOOTLEG',
    'VS',
    'MASHUP',
    'VS_MASHUP',
    'WORDPLAY',
    'VIDEO_MIX',
    'VIDEO_MIXES',
    'MIX'
];
export const PREFERRED_UPLOAD_VERSION_TYPES = [
    'CLEAN',
    'DIRTY',
    'DJ_EDIT',
    'PARTY_STARTER',
    'TRANSITION',
    'HYPE_EDIT',
    'ACAPELLA_IN',
    'ACAPELLA_OUT',
    'BREAKS',
    'REMIX',
    'EXCLUSIVE_REMIX',
    'BOOTLEG',
    'EXCLUSIVE_BOOTLEG',
    'VS',
    'MASHUP',
    'WORDPLAY',
    'VIDEO_MIX'
];
export const VERSION_FILTER_OPTIONS = [
    { code: 'CLEAN', label: 'Clean', matchCodes: ['CLEAN'] },
    { code: 'DIRTY', label: 'Dirty', matchCodes: ['DIRTY'] },
    { code: 'DJ_EDIT', label: 'DJ Edit', matchCodes: ['DJ_EDIT'] },
    { code: 'PARTY_STARTER', label: 'Party Starters', matchCodes: ['PARTY_STARTER', 'PARTY_STARTERS'] },
    { code: 'TRANSITION', label: 'Transitions', matchCodes: ['TRANSITION', 'TRANS'] },
    { code: 'HYPE_EDIT', label: 'Hype Edits', matchCodes: ['HYPE_EDIT'] },
    { code: 'ACAPELLA_IN', label: 'Acapella In', matchCodes: ['ACAPELLA_IN'] },
    { code: 'ACAPELLA_OUT', label: 'Acapella Out', matchCodes: ['ACAPELLA_OUT'] },
    { code: 'BREAKS', label: 'Breaks', matchCodes: ['BREAKS'] },
    { code: 'REMIX', label: 'Remix', matchCodes: ['REMIX'] },
    { code: 'BOOTLEG', label: 'Bootlegs', matchCodes: ['BOOTLEG'] },
    { code: 'VS', label: 'VS', matchCodes: ['VS', 'VS_MASHUP'] },
    { code: 'MASHUP', label: 'Mashups', matchCodes: ['MASHUP', 'VS_MASHUP'] },
    { code: 'WORDPLAY', label: 'Wordplay', matchCodes: ['WORDPLAY'] },
    { code: 'VIDEO_MIX', label: 'Video Mixes', matchCodes: ['VIDEO_MIX', 'VIDEO_MIXES', 'MIX'] },
    { code: 'EXCLUSIVE_REMIX', label: 'Exclusive Remixes', matchCodes: ['EXCLUSIVE_REMIX', 'EXCLUSIVE_REMIX_2'] },
    { code: 'EXCLUSIVE_BOOTLEG', label: 'Exclusive Bootlegs', matchCodes: ['EXCLUSIVE_BOOTLEG'] }
];
export const VERSION_LABELS = {
    CLEAN: 'Clean',
    DIRTY: 'Dirty',
    DJ_EDIT: 'DJ Edit',
    INTRO: 'Intro',
    ACAPELLA_IN: 'Acapella In',
    ACAPELLA_OUT: 'Acapella Out',
    PARTY_STARTER: 'Party Starter',
    PARTY_STARTERS: 'Party Starter',
    TRANS: 'Transition',
    TRANSITION: 'Transition',
    HYPE_EDIT: 'Hype Edit',
    BREAKS: 'Breaks',
    REMIX: 'Remix',
    EXCLUSIVE_REMIX: 'Exclusive Remix',
    EXCLUSIVE_REMIX_2: 'Exclusive Remix',
    BOOTLEG: 'Bootleg',
    EXCLUSIVE_BOOTLEG: 'Exclusive Bootleg',
    VS: 'VS',
    MASHUP: 'Mashup',
    VS_MASHUP: 'VS / Mashup Legacy',
    WORDPLAY: 'Wordplay',
    VIDEO_MIX: 'Video Mix',
    VIDEO_MIXES: 'Video Mix',
    MIX: 'Video Mix'
};
export const VERSION_FILENAME_LABELS = {
    ...VERSION_LABELS,
    VS_MASHUP: 'VS / Mashup'
};
export const VERSION_SORT_ORDER = {
    CLEAN: 1,
    DIRTY: 2,
    DJ_EDIT: 3,
    INTRO: 4,
    ACAPELLA_IN: 5,
    ACAPELLA_OUT: 6,
    PARTY_STARTER: 7,
    PARTY_STARTERS: 7,
    TRANS: 8,
    TRANSITION: 8,
    HYPE_EDIT: 9,
    BREAKS: 10,
    REMIX: 11,
    EXCLUSIVE_REMIX: 12,
    EXCLUSIVE_REMIX_2: 12,
    BOOTLEG: 13,
    EXCLUSIVE_BOOTLEG: 14,
    VS: 15,
    MASHUP: 16,
    VS_MASHUP: 16,
    WORDPLAY: 17,
    VIDEO_MIX: 18,
    VIDEO_MIXES: 18,
    MIX: 18
};
const VERSION_TYPE_SET = new Set(VERSION_TYPES);
const VERSION_FILTER_MATCHES = new Map(VERSION_FILTER_OPTIONS.map((option) => [
    option.code,
    new Set(option.matchCodes.map(normalizeVersionCode))
]));
export function normalizeVersionCode(value) {
    return value.trim().toUpperCase().replace(/[^A-Z0-9]+/g, '_').replace(/^_+|_+$/g, '');
}
export function isVersionType(value) {
    return Boolean(value && VERSION_TYPE_SET.has(value));
}
export function getVersionLabel(value) {
    return isVersionType(value) ? VERSION_LABELS[value] : undefined;
}
export function getVersionFilenameLabel(value) {
    return isVersionType(value) ? VERSION_FILENAME_LABELS[value] : undefined;
}
export function getVersionSortOrder(value) {
    return isVersionType(value) ? VERSION_SORT_ORDER[value] : 999;
}
export function versionMatchesFilter(versionType, filterCode) {
    if (!versionType)
        return false;
    return VERSION_FILTER_MATCHES.get(filterCode)?.has(normalizeVersionCode(versionType)) || false;
}
